import React from 'react';

const PriceSummary = ({
  equipmentDailyTotal,
  crewDailyTotal,
  totalEquipmentItems,
  crewCount,
  startDate,
  endDate,
  totalValue
}) => {
  const calculateDays = () => {
    if (!startDate || !endDate) return 1;
    const start = new Date(startDate);
    const end = new Date(endDate);
    return Math.max(1, Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1);
  };

  const days = calculateDays();

  if ((totalEquipmentItems === 0 && crewCount === 0) || !startDate || !endDate) {
    return null;
  }

  return (
    <div className="border-t pt-4 bg-green-50 -mx-6 px-6 pb-2 rounded-b-lg">
      <div className="text-sm space-y-1">
        <div className="flex justify-between text-gray-600">
          <span>Apparatuur ({totalEquipmentItems} items):</span>
          <span>€{equipmentDailyTotal.toFixed(2)}/dag</span>
        </div>
        <div className="flex justify-between text-gray-600">
          <span>Personeel ({crewCount} leden):</span>
          <span>€{crewDailyTotal.toFixed(2)}/dag</span>
        </div>
        <div className="flex justify-between text-gray-600">
          <span>Projectduur:</span>
          <span>{days} dagen</span>
        </div>
        <div className="flex justify-between font-semibold text-green-700 pt-2 border-t border-green-200">
          <span>Totale Projectwaarde:</span>
          <span>€{parseFloat(totalValue || 0).toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default PriceSummary;
